import './menu-second-level.scss';

import PubSub from 'pubsub-js';
import { PageEvents } from './page';
import { Responsive } from '../utils';

const COMPONENT_NAME = 'menu-second-level';
// const EVENT_KEY = COMPONENT_NAME;
const BEM = {
  BLOCK: COMPONENT_NAME,
  ELEMENT_SLIDER: 'menu-second-level__list',
  ELEMENT_SLIDER_ITEM: 'menu-second-level__list__item',
  ELEMENT_SLIDER_ITEM_ACTIVE: 'menu-second-level__list__item__link--active',
  ELEMENT_SLIDE: 'menu-second-level__slide',
  ELEMENT_SLIDER_LIST: 'slick-track',
  MODIFIER_CONTENT_SHOW: 'menu-second-level__content--show',
};

/**
 * version    1.0
 * class      <type> (Menu Second Level)
 */
export class MenuSecondLevel {
  constructor($container = $('body')) {
    const self = this;

    this._vars = {
      maxHeight: 0,
    };

    // find elements
    this._els = {};
    this._els.container = $container;
    this._els.menuSecondLevel = this._els.container.find(`.${BEM.BLOCK}`);

    // init UI
    PubSub.subscribe(PageEvents.PAGE_READY, () => {
      this._els.menuSecondLevel.each(function () {
        self._initSingleInstance($(this));
        self._checkUrlArrowsArray($(this));
        self._animateSliderContainer($(this));
        self._checkIfDesktop($(this));
      });
    });
  }

  _checkIfDesktop() {
    // Si suppone "desktop" solo da 1025px di larghezza del viewport in su; altrimenti è "mobile".
    // È l'unica distinzione presa in esame.
    const breakpoint = Responsive.getCurrentBreakpointName();
    return breakpoint === 'md' || breakpoint === 'lg';
  }

  _animateSliderContainer() {
    const positionItem = $(`.${BEM.ELEMENT_SLIDER}`).find(`.${BEM.ELEMENT_SLIDER_ITEM_ACTIVE}`).offset().left - 100;
    setTimeout(() => {
      // eslint-disable-next-line prefer-template
      $(`.${BEM.ELEMENT_SLIDER_LIST}`).css('transform', 'translate3d(' + -positionItem + 'px, 0, 0)');
    }, 1000);
  }

  _checkUrlArrowsArray() {
    /* eslint-disable */
      var index = 0;
      var url = window.location.pathname;
      var id = $(`.${BEM.BLOCK}`).data('second-level-menu-id');
      var found = false;
      var prev, next;

      while(found === false && SECOND_LEVEL_MENU_CONTENT[id]['pages'].length >= index){
          if (url == SECOND_LEVEL_MENU_CONTENT[id]['pages'][index]){
              found = true;
              prev = index - 1;
              next = index + 1;
          } else {
              index++;
          }
      }

      if (found){
        const urlPrev = SECOND_LEVEL_MENU_CONTENT[id]['pages'][prev];
        const urlNext = SECOND_LEVEL_MENU_CONTENT[id]['pages'][next];
        var buttonPrev = document.getElementById('arrow-menu-second-level--prev');
        var buttonNext = document.getElementById('arrow-menu-second-level--next');
        var $slickNext = $('#slick-prev-arrow');
        $(buttonPrev).attr("href", urlPrev);
        $(buttonNext).attr("href", urlNext);
        if($slickNext.hasClass('slick-disabled')){
          $slickNext.removeClass(".slick-disabled");
        }
        if (typeof urlPrev  !== "undefined" ) {
          $(buttonPrev).show();
          //enable the arrow
          if($slickNext.hasClass('slick-disabled')){
            $slickNext.removeClass('slick-disabled');
          }
        } else {
          $(buttonPrev).hide();
          if(!$slickNext.hasClass('slick-disabled')){
            $slickNext.addClass('slick-disabled');
          }
        }
        if (typeof urlNext  !== "undefined") {
          $(buttonNext).show();
        } else {
          $(buttonNext).hide();
        }
      } else {}
  }

  _initSingleInstance($instanceEl) {
    const self = this;
    self._initSlider($instanceEl);
  }

  // init the slider in case the instance contains more than one slide
  _initSlider($instanceEl) {
    const $sliderItems = $instanceEl.find(`.${BEM.ELEMENT_SLIDER_ITEM}`);

    const optionsSlider = {
      accessibility: false,
      variableWidth: true,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      infinite: false,
      swipeToSlide: true,
      centeredMode: true,
      nextArrow: '<button type="button" id="slick-next-arrow" class="slick-next" aria-label="Next"><svg role="img" aria-hidden="true" class="svg-icon svg-icon--arrow-left-slider" title="Next"><use xlink:href="#sprite-chevron-right"></use></svg></button>',
      prevArrow: '<button type="button" id="slick-prev-arrow" class="slick-prev" aria-label="Previous"><svg role="img" aria-hidden="true" class="svg-icon svg-icon--arrow-left-slider" title="Previous"><use xlink:href="#sprite-chevron-right"></use></svg></button>',
    };

    if ($sliderItems.length > 1) {
      $instanceEl.find(`.${BEM.ELEMENT_SLIDER}`).slick(optionsSlider);
      $(`.${BEM.ELEMENT_SLIDER}`).find('.slick-slide[aria-hidden="true"]').removeAttr('aria-hidden');
    }
  }
}
